import {
  FETCH_AWARD,
  PARTICIPANT_COMPANIES,
} from './types';


export default {
  [FETCH_AWARD]: (state, payload) => {
    state.award = payload.award;
  },
  [PARTICIPANT_COMPANIES]: (state, payload) => {
    const { results } = payload.data;
    const newResults = results.map(res => ({ ...res, name: res.details.name }));
    state.participantCompanies = [...state.participantCompanies, ...newResults];
  },
};
